
document.addEventListener('DOMContentLoaded', function () {
  
  document.querySelectorAll('.template-product [data-add-btn]').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      console.log('hiii');

      const mainBtn = document.querySelector('.product-form__buttons .product-form__submit');
      if (mainBtn) {
        // Smooth scroll into view
        mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => {
          mainBtn.click();
        }, 500);
      }
    });
  });

 
  const widgetWrapper = document.querySelector('.recharge-subscription-widget'); 

  // ✅ Only add label if wrapper AND inner element exist
  if (widgetWrapper && widgetWrapper.querySelector('recharge-subscription-widget')) {
    // Prevent duplicate label
    if (!widgetWrapper.previousElementSibling || !widgetWrapper.previousElementSibling.classList.contains('frequency-label')) {
      const label = document.createElement('label');
      label.textContent = "Choose your purchasing method";
      label.className = 'frequency-label';
      label.style.display = 'block';
      label.style.marginBottom = '8px';

      widgetWrapper.parentNode.insertBefore(label, widgetWrapper);
    }
  }






});

document.addEventListener("DOMContentLoaded", () => {
  // Wait for the Recharge widget to load
  const observer = new MutationObserver(() => {
    const widgetRoot = document.querySelector('.rc-widget__root');

    if (widgetRoot && widgetRoot.shadowRoot) {
      const shadow = widgetRoot.shadowRoot;
      const style = document.createElement('style');
      style.textContent = `
        .rc-purchase-option {
          border-radius: 50px !important;
        }
      `;
      shadow.appendChild(style);
      observer.disconnect(); // stop once added
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});





